import { UIHeading5, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

interface IFactoidProps {
  title: string;
  value: number;
}

export const Factoid: React.FC<IFactoidProps> = ({ title, value }) => {
  return (
    <div>
      <UIText3 color="text-secondary-default">{title}</UIText3>
      <UIHeading5>{value}</UIHeading5>
    </div>
  );
};
